<template>
	<div :class="_class" :style="_style" @click="$emit('click', $event)" @mousemove="$emit('mousemove', $event)" @mouseenter="$emit('mouseenter', $event)" @mouseleave="$emit('mouseleave', $event)">
		<div class="type-wrapper" v-if="bgImage">
			<slot></slot>
		</div>
		<slot v-else></slot>
	</div>
</template>

<script>
    // 整块的包装
	export default {
		name: 'type-wrapper',
		props: {
			color: {
				type: String,
				default: ''
			},
			padding: {
				type: Boolean,
				default: false
			},
            // 在padding的基础上限制宽度
			regular: {
				type: Boolean,
				default: false
			},
			bgImage: {
				type: String,
				default: ''
			},
			bgColor: {
				type: String,
				default: ''
			}
		},
		computed: {
			_style() {
				if (this.bgImage) {
					return `
						color: #FFFFFF;
						overflow: hidden;
						background-image: url(${this.bgImage});
						background-attachment: fixed;
						background-position: center center;
                        background-repeat: no-repeat;
						background-size: cover;
					`;
				}
				if (this.color === '') {
					if (['#ffffff', '#fff', 'white', 'transparent', ''].indexOf(this.bgColor.toLowerCase()) > -1) {
						return `
							color: #000000;
							background-color: ${this.bgColor || '#FFFFFF'};
						`;
					}
					return `
						color: #FFFFFF;
						background-color: ${this.bgColor};
					`;
				}
				return `
					color: ${this.color || '#000000'};
					background-color: ${this.bgColor || '#FFFFFF'};
				`;
			},
			_class() {
				if (this.padding) {
					return 'wrapper-padding';
				}
				if (this.regular) {
					return 'wrapper-regular';
				}
				return '';
			}
		}
	}
</script>

<style scoped lang="less">
	.type-wrapper{
		display: inherit;
		flex-wrap: inherit;
		align-items: inherit;
		justify-content: inherit;
		position: relative;
		z-index: 1;
        // 给背景添加一层透明度，一定要够长够宽
		&::before{
			content: '';
			width: 750vw;
			height: 750vh;
			position: absolute;
			top: 50%;
			left: 50%;
			z-index: -2;
			transform: translate(-50%, -50%);
			background-color: rgba(0, 0, 0, 0.23);
		}
        // &::after{
        // 	content: '';
        // 	position: absolute;
        //     top: 0;
        //     left: 0;
        //     right: 0;
        //     bottom: 0;
        // 	z-index: -1;
        //     background-image: inherit;
        //     background-position: center center;
        //     background-repeat: no-repeat;
        //     background-size: cover;
        // }
	}
	@media screen and (min-width: 1440px){
		.wrapper-padding{
			padding: 120px 70px;
		}
		.wrapper-regular{
			padding: 120px calc(50% - 650px);
		}
	}
	@media screen and (min-width: 1280px) and (max-width: 1439px){
		.wrapper-padding, .wrapper-regular{
			padding: 110px 60px;
		}
	}
	@media screen and (min-width: 1080px) and (max-width: 1279px){
		.wrapper-padding, .wrapper-regular{
			padding: 100px 50px;
		}
	}
	@media screen and (min-width: 720px) and (max-width: 1079px){
		.wrapper-padding, .wrapper-regular{
			padding: 80px 40px;
		}
	}
	@media screen and (min-width: 560px) and (max-width: 719px){
		.wrapper-padding, .wrapper-regular{
			padding: 60px 30px;
		}
	}
	@media screen and (max-width: 559px){
		.wrapper-padding, .wrapper-regular{
			padding: 40px 20px;
		}
	}
</style>
